export function EyeClose(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="11"
        viewBox="0 0 24 11"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.27853 1.21453C1.82703 0.72937 1.06772 0.702086 0.582567 1.15359C0.0974123 1.60508 0.0701283 2.36439 0.521627 2.84955C1.13606 3.50978 1.85773 4.10849 2.66689 4.636L1.15142 6.15146C0.682794 6.62009 0.682794 7.37989 1.15142 7.84852C1.62005 8.31715 2.37985 8.31715 2.84848 7.84852L4.84848 5.84852C4.8608 5.83619 4.8728 5.82367 4.88448 5.81095C5.43139 6.0435 6.00215 6.24932 6.59291 6.42651L5.86157 8.62053C5.65199 9.24927 5.99179 9.92885 6.62052 10.1384C7.24925 10.348 7.92883 10.0082 8.13841 9.37948L8.94454 6.96109C9.55043 7.05741 10.17 7.1255 10.8 7.16372V9.59999C10.8 10.2627 11.3372 10.8 12 10.8C12.6627 10.8 13.2 10.2627 13.2 9.59999V7.16373C13.8299 7.12552 14.4495 7.05743 15.0555 6.96112L15.8616 9.37948C16.0711 10.0082 16.7507 10.348 17.3795 10.1384C18.0082 9.92885 18.348 9.24927 18.1384 8.62053L17.4071 6.42656C17.9978 6.24938 18.5686 6.04357 19.1155 5.81103C19.1272 5.82372 19.1391 5.83622 19.1514 5.84852L21.1514 7.84852C21.6201 8.31715 22.3799 8.31715 22.8485 7.84852C23.3171 7.37989 23.3171 6.62009 22.8485 6.15146L21.3331 4.6361C22.1423 4.10857 22.8641 3.50982 23.4785 2.84955C23.93 2.36439 23.9027 1.60508 23.4176 1.15359C22.9324 0.702086 22.1731 0.72937 21.7216 1.21453C19.7809 3.29992 16.2133 4.79998 12.0001 4.79998C7.78682 4.79998 4.21925 3.29992 2.27853 1.21453Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
